module.exports = __webpack_public_path__ + "static/media/clock.f5c64a5f.svg";